import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const ContainerWrapper = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: ${Color.White};
  overflow-x: hidden;
  overflow-y: auto;
`
